import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { getEstadosCategory } from "../../../../../../API/Global/Status/StatusRequests";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import {
  editarRedTelefonia,
  getClaseRed,
  getMarcas,
  getTipoDispositivos,
  guardarRedTelefonia,
} from "../../../../../../API/IT/Dispositivos/DispositivosRequest";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { Toast } from "primereact/toast";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getPersonalRecibeProducto } from "../../../../../../API/RRHH/Personal/PersonalRequests";
import { getActivosFijos } from "../../../../../../API/Global/ActivosFijos/ActivosFijosRequest";

const RedTelefoniaCRUD = ({
  listRedTelefonia,
  showDialog,
  redTelefonia,
  setShowDialog,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tipoDispositivos, setTipoDispositivos] = useState([]);
  const [claseRed, setClaseRed] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [activos, setActivos] = useState([]);

  const initialValues = {
    IdTelefonia: -1,
    IdEstado: redTelefonia ? redTelefonia?.IdEstado : 5,
    IdTipoDispositivo: null,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const marcasTempo = await getMarcas();
    setMarcas(marcasTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const tipoDispositivoTempo = await getTipoDispositivos();
    const filter = tipoDispositivoTempo.filter((e) =>
      [5, 6].includes(e.IdTipoDispositivo)
    );
    setTipoDispositivos(filter);

    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const claseRedTempo = await getClaseRed();
    setClaseRed(claseRedTempo);

    const personalTempo = await getPersonalRecibeProducto();
    setPersonal(personalTempo);

    const activosTempo = await getActivosFijos();
    const activosFilter = activosTempo.filter((e) =>
      [47].includes(e?.IdTipoActivo)
    );
    setActivos(activosFilter);

    const estadoActivo =
      redTelefonia?.IdRed > 0
        ? estadosTempo.find((e) => e.IdStatus === redTelefonia?.IdEstado)
        : estadosTempo.find((e) => e.IdStatus === 5);

    setValues({
      ...redTelefonia,
      TipoDispositivo: filter.find(
        (t) => redTelefonia?.IdTipoDispositivo === t?.IdTipoDispositivo
      ),
      ClaseRed: claseRedTempo.find(
        (c) => redTelefonia.IdClaseRed === c?.IdClase
      ),
      Marca: marcasTempo.find((m) => redTelefonia?.IdMarca === m.IdMarca),
      Area: areasTempo.find((a) => redTelefonia?.IdArea === a.IdArea),
      Estado: estadoActivo,
      Personal: personalTempo.find(
        (p) => redTelefonia?.IdAsignado === p.IdPersonal
      ),
      Activo: activosTempo.find((a) => redTelefonia?.IdActivo === a.IdActivo),
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values?.NombreDispositivo) {
      error.NombreDispositivo = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listRedTelefonia.find(
      (r) =>
        r.IdTelefonia !== values.IdTelefonia &&
        r.DireccionIP === values?.DireccionIP
    );

    if (duplicado) {
      let mensaje = "Ya existe una IP con el mismo valor de: ";
      if (duplicado.DireccionIP === values.DireccionIP)
        mensaje += `${duplicado.DireccionIP} `;
      return mensaje;
    }

    return null;
  };

  const agregar = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toast, "error", "Error", duplicado);
        return;
      }

      const Datos = {
        IdTelefonia: values?.IdTelefonia,
        DireccionIP: values?.DireccionIP,
        NombreDispositivo: values?.NombreDispositivo,
        IdTipoDispositivo: values?.TipoDispositivo?.IdTipoDispositivo,
        Extencion: values?.Extencion,
        IdClaseRed: values?.ClaseRed?.IdClase,
        IdMarca: values?.Marca?.IdMarca,
        Modelo: values?.Modelo,
        Serie: values?.Serie,
        IdArea: values?.Area?.IdArea,
        AnyDesk: values?.AnyDesk,
        IdAsignado: values?.Personal?.IdPersonal,
        Comentario: values?.Comentario,
        IdUserCreated: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        IdActivo: values?.Activo?.IdActivo
      };

      setLoading(true);
      if (Datos.IdTelefonia > 0) {
        const resultado = await editarRedTelefonia(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al Editar", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarRedTelefonia(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al agregar", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={redTelefonia?.IdTelefonia > 0 ? "Editar" : "Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregar();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle =
    redTelefonia?.IdTelefonia > 0
      ? "Editar Red Telefonía"
      : "Agregar Red Telefonía";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "60%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toast} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="DireccionIP"
                    value={values?.DireccionIP}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.DireccionIP ? "p-invalid" : ""}
                  />
                  <label htmlFor="DireccionIP">IP</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="NombreDispositivo"
                    value={values?.NombreDispositivo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.NombreDispositivo ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreDispositivo">Nombre Dispositivo</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values?.Area}
                    items={areas}
                    field={"Area"}
                    label={"Area"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"TipoDispositivo"}
                    value={values?.TipoDispositivo}
                    items={tipoDispositivos}
                    field={"TipoDispositivo"}
                    label={"Tipo Dispositivo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdTipoDispositivo ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Extencion"
                    value={values?.Extencion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Extencion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Extencion">Extensión</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"ClaseRed"}
                    value={values?.ClaseRed}
                    items={claseRed}
                    field={"ClaseRango"}
                    label={"Clase Red"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdClaseRed ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Marca"}
                    value={values?.Marca}
                    items={marcas}
                    field={"Marca"}
                    label={"Marca"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdMarca ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Modelo"
                    value={values?.Modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="mMdelo">Modelo</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="Serie"
                    value={values?.Serie}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="Serie">Serie</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="AnyDesk"
                    value={values?.AnyDesk}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.AnyDesk ? "p-invalid" : ""}
                  />
                  <label htmlFor="AnyDesk">AnyDesk</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Activo"}
                    value={values?.Activo}
                    items={activos}
                    field={"NombreActivo"}
                    label={"Activo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdActivo ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Personal"}
                    value={values?.Personal}
                    items={personal}
                    field={"NombreConcatenado"}
                    label={"Personal"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdAsignado ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-8">
                <span className="p-float-label">
                  <InputTextarea
                    name="Comentario"
                    value={values?.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    rows={1}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RedTelefoniaCRUD;
